<template>
    <BaseInputText
        name="search"
        :data-cy="dataCy"
        :label="hideLabel ? '' : 'Buscar'"
        icon="fas fa-search"
        :placeholder="placeholder"
        :value="searchValue"
        :disabled="disabled"
        @input="handleInput"
    />
</template>

<script setup>
    import { ref, watch, onUnmounted } from 'vue'
    import debounce from 'lodash/debounce'
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue'

    const props = defineProps({
        value: String,
        disabled: Boolean,
        placeholder: String,
        hideLabel: {
            type: Boolean,
            default: false,
        },
        dataCy: String,
    })

    const emit = defineEmits(['input'])

    const searchValue = ref(props.value || '')

    const debouncedEmit = debounce(() => {
        emit('input', searchValue.value)
    }, 500)

    onUnmounted(() => {
        debouncedEmit.cancel()
    })

    function handleInput(val){
        searchValue.value = val
        debouncedEmit()
    }

    watch(() => props.value, val => {
        searchValue.value = val || ''
    })
</script>